import {
  API_HELP_SUCCESS,
  API_HELP_FAILURE,
  API_HELP_LOADING,
  API_SEATTYPES_SUCCESS,
  API_SEATTYPES_FAILURE,
  API_SEATTYPES_LOADING,
  API_CHILDAGES_SUCCESS,
  API_CHILDAGES_LOADING,
  API_CHILDAGES_FAILURE,
  API_PAYMENTCARDTYPES_SUCCESS,
  API_PAYMENTCARDTYPES_FAILURE,
  API_PAYMENTCARDTYPES_LOADING,
  API_PAYMENTCOUNTRIES_SUCCESS,
  API_PAYMENTCOUNTRIES_FAILURE,
  API_PAYMENTCOUNTRIES_LOADING
} from './constants';
import api from '../api';

export function apiHelpFailure(bool) {
  return {
    type: API_HELP_FAILURE,
    hasFailed: bool
  };
}

export function apiHelpIsLoading(bool) {
  return {
    type: API_HELP_LOADING,
    isLoading: bool
  };
}

export const apiHelpSuccess = data => ({
  type: API_HELP_SUCCESS,
  data
});

export const fetchHelpData = id => dispatch => {
  dispatch(apiHelpIsLoading(true));
  return api.info
    .getHelp()
    .then(response => {
      if (response.result === 'error') {
        dispatch(apiHelpIsLoading(false));
        throw Error(response.message);
      }
      dispatch(apiHelpIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiHelpSuccess(response.content)))
    .catch(() => dispatch(apiHelpFailure(true)));
};

// SEAT TYPES

export function apiSeatTypesFailure(bool) {
  return {
    type: API_SEATTYPES_FAILURE,
    hasFailed: bool
  };
}

export function apiSeatTypesIsLoading(bool) {
  return {
    type: API_SEATTYPES_LOADING,
    isLoading: bool
  };
}

export const apiSeatTypesSuccess = data => ({
  type: API_SEATTYPES_SUCCESS,
  data
});

export const fetchSeatTypesData = () => dispatch => {
  dispatch(apiSeatTypesIsLoading(true));
  return api.info
    .getSeatTypes()
    .then(response => {
      if (response.result === 'error') {
        dispatch(apiSeatTypesIsLoading(false));
        throw Error(response.message);
      }
      dispatch(apiSeatTypesIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiSeatTypesSuccess(response)))
    .catch(() => dispatch(apiSeatTypesFailure(true)));
};

// CHILD AGES

export function apiChildAgesFailure(bool) {
  return {
    type: API_CHILDAGES_FAILURE,
    hasFailed: bool
  };
}

export function apiChildAgesIsLoading(bool) {
  return {
    type: API_CHILDAGES_LOADING,
    isLoading: bool
  };
}

export const apiChildAgesSuccess = data => ({
  type: API_CHILDAGES_SUCCESS,
  data
});

export const fetchChildAgesData = () => dispatch => {
  dispatch(apiChildAgesIsLoading(true));
  return api.info
    .GetChildAges()
    .then(response => {
      if (response.result === 'error') {
        dispatch(apiChildAgesIsLoading(false));
        throw Error(response.message);
      }
      dispatch(apiChildAgesIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiChildAgesSuccess(response)))
    .catch(() => dispatch(apiChildAgesFailure(true)));
};

//CARDTYPES

export function apiPaymentCardTypesFailure(bool) {
  return {
    type: API_PAYMENTCARDTYPES_FAILURE,
    hasFailed: bool
  };
}

export function apiPaymentCardTypesIsLoading(bool) {
  return {
    type: API_PAYMENTCARDTYPES_LOADING,
    isLoading: bool
  };
}

export const apiPaymentCardTypesSuccess = data => ({
  type: API_PAYMENTCARDTYPES_SUCCESS,
  data
});

export const fetchPaymentCardTypesData = () => dispatch => {
  dispatch(apiPaymentCardTypesIsLoading(true));
  return api.info
    .getPaymentCardTypes()
    .then(response => {
      if (response.result === 'error') {
        dispatch(apiPaymentCardTypesIsLoading(false));
        throw Error(response.message);
      }
      dispatch(apiPaymentCardTypesIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiPaymentCardTypesSuccess(response)))
    .catch(() => dispatch(apiPaymentCardTypesFailure(true)));
};

//PAYMENTCOUNTRIES

export function apiPaymentCountriesFailure(bool) {
  return {
    type: API_PAYMENTCOUNTRIES_FAILURE,
    hasFailed: bool
  };
}

export function apiPaymentCountriesIsLoading(bool) {
  return {
    type: API_PAYMENTCOUNTRIES_LOADING,
    isLoading: bool
  };
}

export const apiPaymentCountriesSuccess = data => ({
  type: API_PAYMENTCOUNTRIES_SUCCESS,
  data
});

export const fetchPaymentCountriesData = () => dispatch => {
  dispatch(apiPaymentCountriesIsLoading(true));
  return api.info
    .getPaymentCountries()
    .then(response => {
      if (response.result === 'error') {
        dispatch(apiPaymentCountriesIsLoading(false));
        throw Error(response.message);
      }
      dispatch(apiPaymentCountriesIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiPaymentCountriesSuccess(response)))
    .catch(() => dispatch(apiPaymentCountriesFailure(true)));
};



// WEBPACK FOOTER //
// ./src/actions/info.js